export interface QuestionnaireItem {
  id: string;
  requestId: string;
  requestType: string;
  questionNo: number;
  values: number;
  codebookId: string | null;
  trailerQTY: number;
  countryId: string | null;
}

export const transformRequestFormData1 = (data: Record<string, any>) => {
  const QuestionnaireListJson: QuestionnaireItem[] = [];

  Object.keys(data).forEach((key) => {
    if (key.startsWith("question")) {
      // key looks like: question1_value / question2_codebookId / question3_trailerQTY
      const [, num, type] = key.split("_");
      const questionNo = Number(num);

      const value = data[key];

      if (Array.isArray(value)) {
        value.forEach((val) => {
          QuestionnaireListJson.push({
            id: "", // you said no uuid
            requestId: "",
            requestType: data.type,
            questionNo,
            values: type === "value" ? Number(val) || 0 : 0,
            codebookId: type === "codebookId" ? val : null,
            trailerQTY: type === "trailerQTY" ? Number(val) || 0 : 0,
            countryId: type === "countryId" ? val : null,
          });
        });
      } else {
        QuestionnaireListJson.push({
          id: "",
          requestId: "",
          requestType: data.type,
          questionNo,
          values: type === "value" ? Number(value) || 0 : 0,
          codebookId: type === "codebookId" ? value : null,
          trailerQTY: type === "trailerQTY" ? Number(value) || 0 : 0,
          countryId: type === "countryId" ? value : null,
        });
      }
    }
  });

  // keep only non-question fields
  const rest = Object.fromEntries(
    Object.entries(data).filter(([key]) => !key.startsWith("question"))
  );

  return {
    ...rest,
    QuestionnaireListJson,
  };
};

export const transformRequestFormData2 = (data: Record<string, any>) => {
  const QuestionnaireListJson: QuestionnaireItem[] = [];

  // Helper to push items safely
  const pushItem = (
    questionNo: number,
    values = 0,
    codebookId: string | null = null,
    trailerQTY = 0,
    countryId: string | null = null
  ) => {
    QuestionnaireListJson.push({
      id: "",
      requestId: "",
      requestType: data.type,
      questionNo,
      values,
      codebookId,
      trailerQTY,
      countryId,
    });
  };

  // 1️⃣ Total number of vehicles
  if (data.question_1_values !== undefined) {
    pushItem(1, Number(data.question_1_values) || 0);
  }

  // 2️⃣ Trailers by type (array)
  if (Array.isArray(data.trailers)) {
    data.trailers.forEach((item: any) => {
      if (item.question_2_codebookId || item.question_2_trailerQTY) {
        pushItem(
          2,
          0,
          item.question_2_codebookId || null,
          Number(item.question_2_trailerQTY) || 0
        );
      }
    });
  }

  // 3️⃣ CEMT permits (array)
  if (Array.isArray(data.cemtPermits)) {
    data.cemtPermits.forEach((item: any) => {
      if (item.question_3_codebookId || item.question_3_countryId) {
        pushItem(
          3,
          0,
          item.question_3_codebookId || null,
          0,
          item.question_3_countryId || null
        );
      }
    });
  }

  // 4️⃣ Certifications  (multi-select)
  if (Array.isArray(data.question_4_codebookId)) {
    data.question_4_codebookId.forEach((id: string) => {
      pushItem(4, 0, id);
    });
  }

  // 4️⃣ licenses (multi-select)
  if (Array.isArray(data.question_5_codebookId)) {
    data.question_5_codebookId.forEach((id: string) => {
      pushItem(5, 0, id);
    });
  }

  // 5️⃣ Countries of operation (multi-select)
  if (Array.isArray(data.question_6_countryId)) {
    data.question_6_countryId.forEach((id: string) => {
      pushItem(6, 0, null, 0, id);
    });
  }

  // 7️⃣ Special licence (multi-select)
  if (Array.isArray(data.question_7_codebookId)) {
    data.question_7_codebookId.forEach((id: string) => {
      pushItem(7, 0, id);
    });
  } else if (data.question_7_codebookId !== undefined) {
    // Handle single value for backward compatibility
    pushItem(7, 0, data.question_7_codebookId);
  }

    // 7️⃣ type of transport (multi-select)
    if (Array.isArray(data.question_10_codebookId)) {
      data.question_10_codebookId.forEach((id: string) => {
        pushItem(10, 0, id);
      });
    } else if (data.question_10_codebookId !== undefined) {
      // Handle single value for backward compatibility
      pushItem(10, 0, data.question_10_codebookId);
    }

  // 8️⃣ Vehicle Types (array) - Question 4
  if (Array.isArray(data.vehicles)) {
    data.vehicles.forEach((item: any) => {
      if (item.question_8_codebookId || item.question_8_vehicleQTY) {
        pushItem(
          8,
          Number(item.question_8_vehicleQTY) || 0,
          item.question_8_codebookId || null,
          0
        );
      }
    });
  }

  // 9️⃣ Body Types (array) - Question 5
  if (Array.isArray(data.body)) {
    data.body.forEach((item: any) => {
      if (item.question_9_codebookId || item.question_9_bodyQTY) {
        pushItem(
          9,
          Number(item.question_9_bodyQTY) || 0,
          item.question_9_codebookId || null,
          0
        );
      }
    });
  }

  // if (data.question_8_codebookId !== undefined) {
  //   pushItem(7, 0, data.question_8_codebookId);
  // }

  // if (data.question_9_codebookId !== undefined) {
  //   pushItem(7, 0, data.question_9_codebookId);
  // }

  // Filter out non-question fields for submission
  const rest = Object.fromEntries(
    Object.entries(data).filter(
      ([key]) =>
        !key.startsWith("question_") &&
        key !== "trailers" &&
        key !== "cemtPermits" &&
        key !== "vehicles" &&
        key !== "body"
    )
  );

  return {
    ...rest,
    QuestionnaireListJson,
  };
};

type KeyValuePair = [string, any];

/**
 * Modifies specific keys in a key-value pair array based on request type.
 *
 * @param data - Array of [key, value] pairs
 * @param requestType - Request type identifier
 * @returns Modified array of [key, value] pairs
 */

export const transformRequestData = (
  data: Record<string, any> | [string, any][],
  requestType: number | string,
  codebooks?: Record<string, any>
): Record<string, any> => {
  const entries = Array.isArray(data) ? data : Object.entries(data);
  const type = Number(requestType);

  // 🔹 Rename mappings
  const renameMapType1: Record<string, string> = {
    question_1_value: "shipFrequency",
    question_2_codebookid: "plannedGoods",
    question_3_trailerqty: "shipmentSize",
  };

  const renameMapType2: Record<string, string> = {
    question_1_values: "vehicalFleet",
    question_2_codebookid: "trailerType",
    question_2_trailerqty: "Trailer QTY",
    question_3_codebookid: "cemtPermit",
    question_3_countryid: "country",
    question_4_codebookid: "certificate",
    question_5_codebookid: "licenses",
    question_6_countryid: "operatingCountry",
    question_7_codebookid: "specialLicence",
    question_8_codebookid: "vehicleType",
    question_8_vehicleqty: "Vehicle QTY",
    question_9_codebookid: "bodyType",
    question_9_bodyqty: "Body QTY",
    question_10_codebookid:"typeOfTransport",
  };

  const trailerQtyMap: Record<string, string> = {
    "1": "LTL",
    "2": "Groupage",
    "3": "FTL",
  };

  const shipMap: Record<string, string> = {
    "1": "I have only one shipment",
    "2": "I ship frequently",
  };

  const modified = entries.map(([key, value]) => {
    const lowerKey = key.toLowerCase();
    const renameMap = type === 1 ? renameMapType1 : renameMapType2;
    const newKey = renameMap[lowerKey] || key;
    let newValue = value;

    if (lowerKey === "countryid" && codebooks?.Country) {
      const match = codebooks.Country.find((c: any) => c.id === value);
      newValue = match ? match.name : value;
    }

    // 🧩 TYPE 1 — Transformations
    if (type === 1) {
      if (
        newKey === "plannedGoods" &&
        Array.isArray(value) &&
        codebooks?.GoodsType
      ) {
        newValue = value.map((id: string) => {
          const match = codebooks.GoodsType.find((g: any) => g.id === id);
          return match ? match.name : id;
        });
      }

      if (newKey === "shipmentSize" && Array.isArray(value)) {
        newValue = value.map((val: string) => trailerQtyMap[val] || val);
      }

      if (newKey === "shipFrequency") {
        if (Array.isArray(value)) {
          newValue = value.map((val: string) => shipMap[val] || val);
        } else {
          newValue = shipMap[value] || value;
        }
      }
    }

    // 🧩 TYPE 2 — Transformations
    if (type === 2) {
      // 1️⃣ Nested trailers
      if (lowerKey === "trailers" && Array.isArray(value)) {
        newValue = value.map((item) => {
          const transformed: Record<string, any> = {};
          for (const [k, v] of Object.entries(item)) {
            const innerKey = renameMap[k.toLowerCase()] || k;
            let innerValue = v;

            if (innerKey === "trailerType" && codebooks?.TrailerType) {
              const match = codebooks.TrailerType.find((t: any) => t.id === v);
              innerValue = match ? match.name : v;
            }

            transformed[innerKey] = innerValue;
          }
          return transformed;
        });
      }

      // 2️⃣ Nested CEMT Permits
      if (lowerKey === "cemtpermits" && Array.isArray(value)) {
        newValue = value.map((item) => {
          const transformed: Record<string, any> = {};
          for (const [k, v] of Object.entries(item)) {
            const innerKey = renameMap[k.toLowerCase()] || k;
            let innerValue = v;

            if (innerKey === "cemtPermit" && codebooks?.CemtPermit) {
              const match = codebooks.CemtPermit.find((c: any) => c.id === v);
              innerValue = match ? match.name : v;
            }

            if (innerKey === "country" && codebooks?.Country) {
              const match = codebooks.Country.find((c: any) => c.id === v);
              innerValue = match ? match.name : v;
            }

            transformed[innerKey] = innerValue;
          }
          return transformed;
        });
      }

      // 3️⃣ Certificate
      if (
        newKey === "certificate" &&
        Array.isArray(value) &&
        codebooks?.Certificate
      ) {
        newValue = value.map((id: string) => {
          const match = codebooks.Certificate.find((c: any) => c.id === id);
          return match ? match.name : id;
        });
      }

      // 3️⃣  Licenses
      if (newKey === "licenses" && Array.isArray(value) && codebooks?.License) {
        newValue = value.map((id: string) => {
          const match = codebooks.License.find((c: any) => c.id === id);
          return match ? match.name : id;
        });
      }

      // 4️⃣ Country list (question_5_countryId)
      if (
        newKey === "operatingCountry" &&
        Array.isArray(value) &&
        codebooks?.OperatingCountry
      ) {
        newValue = value.map((id: string) => {
          const match = codebooks.OperatingCountry.find(
            (c: any) => c.id === id
          );
          return match ? match.name : id;
        });
      }

      // 3️⃣  specialLicence (multi-select)
      if (newKey === "specialLicence" && Array.isArray(value) && codebooks?.SpecialLicence) {
        newValue = value.map((id: string) => {
          const match = codebooks.SpecialLicence.find((c: any) => c.id === id);
          return match ? match.name : id;
        });
      } else if (newKey === "specialLicence" && codebooks?.SpecialLicence) {
        // Handle single value for backward compatibility
        const match = codebooks.SpecialLicence.find((c: any) => c.id === value);
        newValue = match ? match.name : value;
      }

      if (newKey === "typeOfTransport" && Array.isArray(value) && codebooks?.TransportType) {
        newValue = value.map((id: string) => {
          const match = codebooks.TransportType.find((c: any) => c.id === id);
          return match ? match.name : id;
        });
      } else if (newKey === "typeOfTransport" && codebooks?.TransportType) {
        // Handle single value for backward compatibility
        const match = codebooks.TransportType.find((c: any) => c.id === value);
        newValue = match ? match.name : value;
      }

      // 4️⃣ Nested Vehicle Types
      if (lowerKey === "vehicles" && Array.isArray(value)) {
        newValue = value.map((item) => {
          const transformed: Record<string, any> = {};
          for (const [k, v] of Object.entries(item)) {
            const innerKey = renameMap[k.toLowerCase()] || k;
            let innerValue = v;

            if (innerKey === "vehicleType" && codebooks?.VehicleType) {
              const match = codebooks.VehicleType.find((t: any) => t.id === v);
              innerValue = match ? match.name : v;
            }

            transformed[innerKey] = innerValue;
          }
          return transformed;
        });
      }

      // 5️⃣ Nested Body Types
      if (lowerKey === "body" && Array.isArray(value)) {
        newValue = value.map((item) => {
          const transformed: Record<string, any> = {};
          for (const [k, v] of Object.entries(item)) {
            const innerKey = renameMap[k.toLowerCase()] || k;
            let innerValue = v;

            if (innerKey === "bodyType" && codebooks?.BodyType) {
              const match = codebooks.BodyType.find((t: any) => t.id === v);
              innerValue = match ? match.name : v;
            }

            transformed[innerKey] = innerValue;
          }
          return transformed;
        });
      }
    }

    return [newKey, newValue];
  });

  return Object.fromEntries(modified);
};
